import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';

const FormHttpAlert = ({
  theme = 'danger',
  children,
  onClose,
}) => (
  <div className={`alert alert-${theme}`}>
    <div className="form-row">
      <div className="col-auto">
        <FA icon={faExclamationCircle} />
      </div>
      <div className="col text-break">
        {children}
      </div>
      {onClose && (
        <div className="col-auto">
          <button
            type="button"
            className="close"
            onClick={onClose}
          >
            <small><FA icon={faTimes} /></small>
          </button>
        </div>
      )}
    </div>
  </div>
);

export default FormHttpAlert;
